import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import BrandWordmark from '../BrandWordmark'
import AdminDashboard from '../AdminDashboard'
import AdminLoginPage from './AdminLoginPage'

type Props = {
  token: string | null
  userRole?: string
  userEmail?: string
  onLogin: (token: string, user: unknown) => void
  onLogout: () => void
  onGoToSite: () => void
}

export default function AdminPortal({ token, userRole, userEmail, onLogin, onLogout, onGoToSite }: Props) {
  const { t, i18n } = useTranslation()
  const [lastUpdated, setLastUpdated] = useState<Date | null>(null)
  const isAdmin = !!token && userRole === 'admin'

  if (!isAdmin) {
    return (
      <div className="vc-admin-portal">
        <AdminLoginPage
          onLogin={onLogin}
          accessDenied={!!token && userRole !== 'admin'}
          onGoToSite={onGoToSite}
          onLogout={onLogout}
        />
      </div>
    )
  }

  return (
    <div className="vc-admin-portal vc-admin-portal--dashboard">
      <header className="vc-admin-topbar">
        <div className="vc-admin-topbar__brand">
          <BrandWordmark className="vc-admin-topbar__logo" wordmarkOnly title="reDevicer" />
          <span className="vc-admin-topbar__title">{t('admin.panelSubtitle')}</span>
        </div>
        <div className="vc-admin-topbar__actions">
          {lastUpdated ? (
            <span className="vc-admin-topbar__updated">
              {t('admin.lastUpdated', {
                time: lastUpdated.toLocaleTimeString(i18n.language, { hour: '2-digit', minute: '2-digit' }),
              })}
            </span>
          ) : null}
          {userEmail ? <span className="vc-admin-topbar__user">{userEmail}</span> : null}
          <button type="button" className="vc-admin-topbar__link" onClick={onGoToSite}>
            {t('admin.backToSite')}
          </button>
          <button type="button" className="vc-admin-topbar__logout" onClick={onLogout}>
            {t('admin.logout')}
          </button>
        </div>
      </header>
      <AdminDashboard token={token!} onLastUpdated={setLastUpdated} />
    </div>
  )
}
